import React from "react";

const Designer = props => {
  return <h1>Welcome to personal designer!</h1>;
};

export default Designer;